const STORAGE_KEY = 'drivelog365_panel_tokens';

/**
 * Load tokens from localStorage. Returns null if missing, invalid, or both tokens expired.
 */
export function loadTokensFromStorage() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || typeof data !== 'object') return null;

    const now = Date.now();
    const accessExp = data.accessTokenExpiration ? new Date(data.accessTokenExpiration).getTime() : 0;
    const refreshExp = data.refreshTokenExpiration ? new Date(data.refreshTokenExpiration).getTime() : 0;

    // Don't restore if both tokens are expired (avoid brief "logged in" then redirect)
    if (accessExp && refreshExp && accessExp < now && refreshExp < now) return null;

    return {
      accessToken: data.accessToken || '',
      refreshToken: data.refreshToken || '',
      userEmail: data.userEmail || '',
      userPhoneNumber: data.userPhoneNumber || '',
      accessTokenExpiration: data.accessTokenExpiration ?? null,
      refreshTokenExpiration: data.refreshTokenExpiration ?? null,
      userRole: data.userRole || '',
    };
  } catch {
    return null;
  }
}

export function saveTokensToStorage(tokensState) {
  try {
    if (!tokensState?.accessToken && !tokensState?.refreshToken) return;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(tokensState));
  } catch (e) {
    console.warn('Failed to persist tokens:', e);
  }
}

export function clearTokensFromStorage() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    console.warn('Failed to clear persisted tokens:', e);
  }
}
